import { UntypedFormGroup } from '@angular/forms';
import { DocumentModel } from 'src/app/shared/models/simple-types/document.model';
import { BpComponentsService } from './../../bp-components.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { saveAs } from 'file-saver';

export interface DialogData {
  idBp: number;
  bp: UntypedFormGroup;
  documents: DocumentModel[];
}

@Component({
  selector: 'app-modal-show-bp-document',
  templateUrl: './modal-show-bp-document.component.html',
  styleUrls: ['./modal-show-bp-document.component.scss']
})

export class ModalShowBpDocumentComponent implements OnInit {

  constructor(public dialog: MatDialog,
              private toastr: ToastrService,
              public router: Router,
              private bpService: BpComponentsService,
              public dialogRef: MatDialogRef<Component>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }

  ngOnInit(): void {
  }

  onModalCancel(): void {
    this.dialogRef.close(false);
  }

  visualiseDoc(doc: DocumentModel, idBp: number): void {
    this.bpService.getDocumentById(idBp, doc.id).subscribe((res: Blob) => {
      const url = URL.createObjectURL(res);
      window.open(url, '_blank');
    });
  }

  onOpenDoc(doc: DocumentModel, idBp: number): void {
    this.bpService.getDocumentById(idBp, doc.id).subscribe((res: Blob) => {
      saveAs(res, doc.code);
    });
  }

  openUrl(): void {
    window.open(this.data.bp.get('urlFacture').value, '_blank')
  }

  onDeleteDoc(idDoc: number, idBp: number): void {
    this.bpService.deleteDocument(idBp, idDoc).subscribe();
  }
}
